import React from "react";
import { X, Mail, ArrowRight } from "lucide-react"; 

const VerificationModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleOpenEmail = () => {
    // Try to open the user's default mail client or webmail in a new tab
    // mailto: will trigger native email apps; if none, the browser will handle gracefully.
    window.location.href = "mailto:";
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 transition-all duration-300">
      <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl p-0 max-w-sm w-full overflow-hidden transform transition-all scale-100 border border-gray-100 dark:border-gray-800">
        
        {/* Header Graphic */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 h-24 flex items-center justify-center relative">
          <div className="bg-white/20 p-4 rounded-full backdrop-blur-md">
            <Mail className="w-8 h-8 text-white" />
          </div>
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white/70 hover:text-white transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        <div className="p-6 text-center">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
            Verify Your Email
          </h2>
          <p className="text-gray-500 dark:text-gray-400 text-sm mb-6 leading-relaxed">
            We've sent a verification link to your inbox. <br/>
            Please click it to activate your account.
          </p>

          <div className="space-y-3">
            <button
              onClick={handleOpenEmail}
              className="w-full bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white py-3 px-4 rounded-xl font-semibold transition-all duration-200 shadow-lg shadow-blue-500/20 flex items-center justify-center gap-2"
            >
              Open Email App
              <ArrowRight size={16} />
            </button>
            <button
              onClick={onClose}
              className="w-full bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 py-3 px-4 rounded-xl font-medium transition-colors"
            >
              Go to homepage
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationModal;
